<template>
    <div>
        <div class="header-box">
            <img class="img1" src="@/assets/image/logo.png" @click="to_Home"/>
            <img class="img2" src="@/assets/image/wap/menu.png" @click="menuShow=!menuShow" v-if="menuShow==false"/>
            <img class="img2" src="@/assets/image/wap/menu2.png" @click="menuShow=!menuShow" v-else/>
        </div>
        <div class="header-menu" v-show="menuShow">
            <div class="header-ul" v-for="item in menuList" :key="item.id">
                <div class="ul-header" @click="routerChange(item.title)">
                    <span>{{item.title}}</span>
                    <template v-if="item.children">

                    </template>
                    <template v-else>

                    </template>
                </div>
                <template v-if="item.children">
                <div class="header-li" v-for="items in item.children" :key="items.id" @click="routerChange(items.title)">
                    {{items.title}}
                </div>
                </template>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "headers",
        data(){
            return{
                menuShow:false,
                menuList:[
                    {
                        id:1,
                        title:"首页",
                        url:""
                    },
                    {
                        id:2,
                        title:"产品",
                        menuShow:false,
                        children:[
                            {
                                id:21,
                                title:"新能源材料",
                                url:""
                            },
                            {
                                id:22,
                                title: "腈类化合物及其衍生物",
                                url:""
                            },
                            {
                                id:23,
                                title: "基础化学品",
                                url:""
                            }
                        ]
                    },
                    {
                        id:3,
                        title:"合作机会",
                        menuShow:false,
                        children:[
                            {
                                id:31,
                                title:"生产资源合作",
                                url:""
                            },
                            {
                                id:32,
                                title: "产品合作",
                                url:""
                            },
                        ]
                    },
                    {
                        id:4,
                        title:"资讯动态",
                        menuShow:false,
                        children:[
                            {
                                id:41,
                                title:"行业资讯",
                                url:""
                            },
                            {
                                id:42,
                                title: "公司动态",
                                url:""
                            },
                        ]
                    },
                    {
                        id:5,
                        title:"关于SPR",
                        menuShow:false,
                        children:[
                            {
                                id:51,
                                title:"公司介绍",
                                url:""
                            },
                            {
                                id:52,
                                title: "职业机会",
                                url:""
                            },
                            {
                                id:53,
                                title: "联系我们",
                                url:""
                            },
                        ]
                    }
                ]
            }
        },
        methods:{
            to_Home(){
                this.menuShow = false;
                this.$router.push({
                    path:'/',
                    query:{wapShow:true}
                },()=>{})
            },
            routerChange(routerName){
                this.menuShow = false;
                switch (routerName) {
                    case '首页':
                        if(pathName == '/')return;
                        this.$router.push({
                            path:'/',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '产品':
                        this.$router.push({
                            path:'/product',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '新能源材料':
                        this.$router.push({
                            path:'/product?type=1',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '腈类化合物及其衍生物':
                        this.$router.push({
                            path:'/product?type=2',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '基础化学品':
                        this.$router.push({
                            path:'/product?type=3',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '合作机会':
                        this.$router.push({
                            path:'/cooperationOpportunities',
                            query:{wapShow:true}
                        });
                        break;
                    case '生产资源合作':
                        this.$router.push({
                            path:'/cooperationOpportunities?type=1',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '产品合作':
                        this.$router.push({
                            path:'/cooperationOpportunities?type=2',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '资讯动态':
                        this.$router.push({
                            path:'/InformationDynamics',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '行业资讯':
                        this.$router.push({
                            path:'/InformationDynamics?type=1',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '公司动态':
                        this.$router.push({
                            path:'/InformationDynamics?type=2',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '关于SPR':
                        this.$router.push({
                            path:'/aboutUs',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '公司介绍':
                        this.$router.push({
                            path:'/aboutUs?type=1',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '职业机会':
                        this.$router.push({
                            path:'/aboutUs?type=2',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                    case '联系我们':
                        this.$router.push({
                            path:'/aboutUs?type=3',
                            query:{wapShow:true}
                        },()=>{});
                        break;
                }
            },
        }
    }
</script>

<style scoped>
    .header-box{
        width: 100%;
        height: 0.88rem;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.05);
        display: flex;
        align-items: center;
        padding: 0 0.2rem;
        justify-content: space-between;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .header-box .img1{
        width: 3.64rem;
        height: 0.32rem;
    }
    .header-box .img2{
        width: 0.46rem;
        height: 0.44rem;
    }

    .header-menu{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 98;
        height: 100%;
        width: 100%;
        overflow: auto;
        background: rgba(255,255,255,0.8);
        backdrop-filter: blur(20px);
        box-sizing: border-box;
        padding: 0.88rem 0 0;

    }
    .header-menu .header-ul{
        border-bottom:0.02rem solid  rgba(0,0,0,0.06);
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F3037;
        padding: 0 0.4rem;
    }
    .header-menu .header-ul .ul-header{
        padding: 0.38rem 0;
    }
    .header-menu .header-li{
        font-size: 0.28rem;
        padding-bottom: 0.48rem;
        padding-left: 0.32rem;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #696970;
    }
</style>
